module.exports = __webpack_public_path__ + "img/65.3789f076.jpg";